const giftReward = {
  // 回归入口内容查询
  queryRecallEntrance: `/authApi/activity/v1/queryRecallEntrance`,
  // 回归主页面内容查询
  queryRecallHomeInfo: `/authApi/activity/v1/queryRecallHomeInfo`,
  // 回归大礼包内容查询
  queryRecallRewardGifts: `/authApi/activity/v1/queryRecallRewardGifts`,
  // 已领取礼包查询
  queryRecallUserUsedGifts: `/authApi/activity/v1/queryRecallUserUsedGifts`,
  // 领取回归奖励礼包
  useRecallRewardGift: `/authApi/activity/v1/useRecallRewardGift`,
  // 猜你喜欢
  queryRecallUserLikeGames: `/authApi/activity/v1/queryRecallUserLikeGames`,
  // 点击链接上报
  recallUserClickLink: `/authApi/activity/v1/recallUserClickLink`,
  // 投票阶段查询
  queryVoteStageInfo: `/authApi/activity/a1014/home/v1/voteStageInfo`
};

export default giftReward;
